import React from 'react';
import classnames from 'classnames';
import dayjs from 'dayjs';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { imageFormat } from '@/utils/format';
import ReportTag from '../ReportTag';
import styles from './index.module.scss';

enum EReportTag {
  'HOTTEST' = 'HOT', //最热
  'LATEST' = 'NEW', //最新
  'PRESELL' = '预售', //预售
  'REFERENCED' = '转载', //转载
  'INFORMATION' = '资讯', // 资讯
}
export type ReportCardProps = {
  id: string;
  reportId: string;
  type?: string;
  title?: string;
  cover?: string;
  hottest?: boolean;
  latest?: boolean;
  preSell?: boolean;
  referenced?: boolean;
  tags?: { id: string; name: string }[];
  clickTimes?: number;
  createTime?: string;
  updateTime?: string;
  className?: string;
};
const ReportCard: React.FC<ReportCardProps> = ({
  reportId,
  type = 'report',
  title,
  cover,
  hottest,
  latest,
  preSell,
  tags = [],
  referenced,
  clickTimes,
  className,
  updateTime,
}) => {
  //   const handleClickUpReport = useCallback(async id => {
  //     try {
  //       await increaseReportClickNum({ id });
  //     } catch (error) {}
  //   }, []);
  const reportTag =
    type === 'information'
      ? 'INFORMATION'
      : hottest
      ? 'HOTTEST'
      : latest
      ? 'LATEST'
      : preSell
      ? 'PRESELL'
      : referenced
      ? 'REFERENCED'
      : '';
  return (
    <div className={classnames(styles.reportCard, className)}>
      {EReportTag[reportTag] && (
        <div className={classnames(styles.reportTag, styles[reportTag])}>{EReportTag[reportTag]}</div>
      )}
      <a
        className={styles.imageContent}
        target="_blank"
        rel="noreferrer"
        href={type === 'report' ? `/report/${reportId}/detail` : `/information/${reportId}`}
        // onClick={() => handleClickUpReport(reportId)}
      >
        <LazyLoadImage
          className={styles.image}
          src={imageFormat(cover, 210, 117)}
          placeholderSrc="//images.dtcj.com/cbndata/icon/loading.gif"
        />
      </a>
      <div
        className={classnames('flex-column-nowrap', 'flex-between-start', styles.bottomContent)}
        // style={{ height: height + 'px' }}
      >
        <div className={styles.header}>
          <a
            className={styles.title}
            href={type === 'report' ? `/report/${reportId}/detail` : `/information/${reportId}`}
            target="_blank"
            rel="noreferrer"
          >
            {title}
          </a>
          <div className={styles.tagList}>
            {tags?.map((item, index) => (
              <ReportTag key={index} text={item.name} />
            ))}
          </div>
        </div>
        <div className={classnames('flex-row-nowrap', 'flex-between-start', styles.bottom)}>
          <div className={classnames('flex-row-nowrap', 'flex-start-center', styles.left)}>
            <svg className="icon" aria-hidden="true">
              <use xlinkHref="#icon-visibility"></use>
            </svg>
            <span className={styles.text}>{clickTimes}</span>
          </div>
          <div>
            {dayjs(updateTime).format('YYYY/MM/DD') === dayjs().format('YYYY/MM/DD')
              ? '今日'
              : dayjs(updateTime).format('YYYY/MM/DD')}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportCard;
